
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar
} from '@mui/material';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import AddBoxIcon from '@mui/icons-material/AddBox';
// import PurchaseEntryPrint from "./PurchaseEntryPrint";
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
// import PurchaseEntryDetails from "./PurchaseEntryDetails";
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, editDeletePurchaseOrder, editDeleteSalesOrder, getDocNoFormateAvailable, getInvoiceSettingList, getPurchaseInvoiceList, getPurchaseOrderList, getSalesOrderList } from "../../../actions/actions";
import DeleteSnackbar from "../../reusableComponent/DeleteSnackbar";
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import AddIcon from '@mui/icons-material/Add';
import { dateConversion, dateConversionOnEntryPage } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import upload_excel from '../../../images/upload_excel.png'
import SalesOrderAdd from "./SalesOrderAdd";
import SalesOrderDetails from "./SalesOrderDetails";
import SalesOrderPrint from "./SalesOrderPrint";
import { BackBtn } from "../../reusableComponent/BackBtn";
import SalesHome from "../salesHome/SalesHome";

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, invoiceSettingList } = props;
    return (
        <div className="print-source" ref={ref}>
            <SalesOrderPrint orderPrint={value} invoiceSettingList={invoiceSettingList} />
        </div>
    );
});
const ComponentToPrintOrderWrapper = ({ orderPrint, invoiceSettingList }) => {

    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" />  <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={orderPrint} invoiceSettingList={invoiceSettingList} />
            </div>
        </div>
    );
};

function SalesOrderList(props) {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);
    // const [open, setOpen] = React.useState(false);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [openOption, setOpenOption] = useState('');

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption(info.so_id ? 'SalesOrderUpdate' : 'SalesOrderAdd')
    };
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [isLoaded, setIsLoaded] = useState(false);

    const [q, setQ] = useState("");
    const [searchParam] = useState(["CNS_Name", "salesOrderNo", "salesOrderDate", "quatationNo", "quatationDate", "paymentTerms", "salesOrderType", "remark", "gst", "basicTotal", "gstTotal", "total", "cgstTotal", "sgstTotal", "igstTotal"]);

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();

    const rows = useSelector(state => state.salesOrder.salesOrder)
    const invoiceSettingList = useSelector(state => state.invoiceSetting.invoiceSetting)
    const docNoFormateAvailable = useSelector(state => state.docNoFormate.docNoFormateAvailable)

    const fetchData = () => {
        dispatch(getSalesOrderList({ companyId: userInfo.companyId }))
        dispatch(getInvoiceSettingList({ companyId: userInfo.companyId }))
        dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Sales Order' }))

    };
    useEffect(() => {
        fetchData()
    }, []);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.salesOrder.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);


    const deleteRecord = (so_id) => {
        dispatch(editDeleteSalesOrder({ id: so_id, modifiedBy: userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
        setAnchorEl(null);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
        setAnchorEl(null);
        setOpenPopup(false);
    };
    const handleDetails = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('SalesOrderDetails')
    }


    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }

    const [sortBy, setSortBy] = useState(null);
    // const handleSort = (property) => {
    //     const isAsc = sortBy === property && sortBy !== null;
    //     setSortBy(isAsc ? property + '_desc' : property);
    //     rows && rows.sort((a, b) => {
    //         if (typeof a[property] === 'number' && typeof b[property] === 'number') {
    //             return isAsc ? a[property] - b[property] : b[property] - a[property];
    //         } else {
    //             return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
    //         }
    //     });
    // };
    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows && rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else if (typeof a[property] === 'string' && typeof b[property] === 'string') {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            } else {
                // Handle other data types here, or you can set a default value if needed
                // For example, you can return 0 to indicate no sorting needed for other data types.
                return 0;
            }
        });
    };
    const fields = ['so_id', 'salesOrderNo', 'salesOrderDate', 'CNS_Name', 'quatationNo', 'quatationDate', 'paymentTerms', 'salesOrderType', 'remark', "gst", "basicTotal", "gstTotal", "total", "cgstTotal", "sgstTotal", "igstTotal"];
    const labels = ['Id', 'Sales Order No', 'Order Date', 'Customer Name', 'Quotation No', 'Quotation Date', 'Payment Term', 'Sles Order Type', 'Remark', "GST", "Basic Total", "GST Total", "Total", "CGST Total", "SGST Total", "IGST Total"];

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };


    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    const navigate = useNavigate()
    const backBtn = props.currentTab
    const navigateToAddEdit = (row) => {
        const state = {
            row,
            invoiceSettingList,
            docNoFormateAvailable,
            backBtn
        };
        navigate('/sales/add-sales-order', { state });
    };

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Sales', path: '/sales/' },
                    { name: 'Sales Order List' },
                ]}
            />
            <SalesHome />
            <Paper className={`${styles.list_container}`}>

                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={7} xs={0}>
                            {/* <Typography className={`${styles.page_title}`}> Sales Order List</Typography> */}
                        </Grid>
                        <Grid item md={5} xs={12} style={{ display: 'flex', }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Sales Order List"
                                />
                            </Box>

                            <TextField
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: '11px',
                                        paddingLeft: '1px',
                                    }
                                }}
                                type="search"
                                name="search"
                                placeholder="Search"
                                value={q}
                                size="small"
                                onChange={(e) => setQ(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" >
                                            <IconButton sx={{ padding: '4px' }}>
                                                <SearchOutlined className={`${styles.search_icon}`} />
                                                <Divider orientation="vertical" flexItem />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Button variant="contained" className={`${styles.add_btn}`} onClick={() => navigateToAddEdit()}>
                                <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>

                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('salesOrderNo')}>Order No <span className={`${styles.sort_icon}`}> {sortBy === 'salesOrderNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('salesOrderDate')}> Order Date <span className={`${styles.sort_icon}`}> {sortBy === 'salesOrderDate' ? '▲' : '▼'}</span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('CNS_Name')}>Customer Name <span className={`${styles.sort_icon}`}> {sortBy === 'CNS_Name' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('quatationNo')}>Quotation No <span className={`${styles.sort_icon}`}> {sortBy === 'quatationNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('quatationDate')}> Quotation Date <span className={`${styles.sort_icon}`}>{sortBy === 'quatationDate' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('paymentTerms')}> Payment Terms <span className={`${styles.sort_icon}`}>{sortBy === 'paymentTerms' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('salesOrderType')}> Sales Order Type <span className={`${styles.sort_icon}`}>{sortBy === 'salesOrderType' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('remark')}> Remark <span className={`${styles.sort_icon}`}>{sortBy === 'remark' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('gst')}> GST <span className={`${styles.sort_icon}`}>{sortBy === 'gst' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('basicTotal')}> Basic Total <span className={`${styles.sort_icon}`}>{sortBy === 'basicTotal' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('gstTotal')}> GST Total <span className={`${styles.sort_icon}`}>{sortBy === 'gstTotal' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('total')}> Total <span className={`${styles.sort_icon}`}>{sortBy === 'total' ? '▲' : '▼'} </span></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {rows && search(rows)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                    <StyledTableRow
                                        key={row.so_id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell align="center" className='listTableBody'>
                                            <PopupState variant="popover" popupId="demo-popup-popover">
                                                {(popupState) => (
                                                    <div>
                                                        <MoreHorizIcon
                                                            id={styles.actionBtn}
                                                            alt="translator"
                                                            variant="contained"
                                                            {...bindTrigger(popupState)}
                                                            />
                                                            <Popover
                                                              
                                                                {...bindPopover(popupState)}
                                                            anchorOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                        >
                                                            <Container className={`${styles.tbl_action}`}>
                                                                <>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => navigateToAddEdit(row)}>
                                                                        <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                        <span style={{ marginRight: '13px' }}> Edit Record</span>
                                                                    </Button>
                                                                    <Button  onClick={popupState.close} className={`${styles.list_tbl_action_btn}`}>
                                                                        <ComponentToPrintOrderWrapper key={index} orderPrint={row} invoiceSettingList={invoiceSettingList} />
                                                                    </Button>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => { handleDelete(row); popupState.close()}}>
                                                                        <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record
                                                                    </Button>
                                                                </>
                                                            </Container>
                                                        </Popover>
                                                    </div>
                                                )}
                                            </PopupState>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDetails(row)}>
                                            <span style={{ cursor: 'pointer', color: 'blue' }} > {row.salesOrderNo}</span>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.salesOrderDate)}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.customerName == null ? '-' : row.CNS_Name}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.quatationNo}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.quatationDate)}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.paymentTerms}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.salesOrderType}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.remark}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.gst}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.basicTotal !== null ? row.basicTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.gstTotal !== null ? row.gstTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.total !== null ? row.total.toFixed(2) : 'N/A'}</StyledTableCell>
                                        {/* <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.cgstTotal !== null ? row.cgstTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.sgstTotal !== null ? row.sgstTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.igstTotal !== null ? row.igstTotal.toFixed(2) : 'N/A'}</StyledTableCell> */}
                                    </StyledTableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={{ px: 2 }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.salesOrderNo}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo.so_id)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        minWidth: "85%",
                        minHeight: "95%"
                    }
                }}
                onClose={handleClose}
                open={openPopup}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'SalesOrderAdd' && 'Add Sales Order'}
                    {openOption === 'SalesOrderUpdate' && 'Update Sales Order'}
                    {openOption === 'SalesOrderDetails' && 'Sales Order Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {(openOption === 'SalesOrderAdd' || openOption === 'SalesOrderUpdate') &&
                        <SalesOrderAdd handleCloseDialog={handleClose} details={info} invoiceSettingList={invoiceSettingList} docNoFormateAvailable={docNoFormateAvailable} onAPISubmit={fetchData} />
                    }
                    {openOption === 'SalesOrderDetails' &&
                        <SalesOrderDetails details={info} invoiceSettingList={invoiceSettingList} />
                    }
                </DialogContent>
            </BootstrapDialog>

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }
        </>
    )
}



export default SalesOrderList